import { createSlice } from "@reduxjs/toolkit";



const EMenuSlice = createSlice({
  name: "EMenu",
  initialState: {
    showCartModal: false,
    categories: [],
    showSection: false,
    TotalPrice: 0,
    DeletedPrice: 0,
    cartItems: [],
    loading: true,
    loadSubCat: true,
    loadProducts: true,
    sub_category: [],
    products: [],
    all_products: [],
    previewItem: false,
    previewedItem: [],
    searchedValue: "",
    searchResult: [],
    companyName: "",
    saveCard: false,
    deliveryMethod: "",
    placeOrder: false,
    menu_type: "",
    item_search: false,
    indoor_selected_value: false,
    review: false,
    reviewQuestions: [],
    questionDetails: [],
    approvedOrder: [],
    groupId: 0,
    activeGroup: null,
    emenuOrderId: "",
    holdApproval: [],
    confirmCancel: false,
    acceptAwaiting: true,
    acceptStatus: "",
    tableMenuId: "",
    viewOrder: false,
    viewItems: false,
    waiterCall: false,
    orderDetails: [],
    favouriteProduct: [],
    favouritePage: false,
    cardViewType: "list",
  },
  reducers: {
    setCardViewType: (state, action) => {
      state.cardViewType = action.payload;
      console.log(action.payload);
    },
    addToCart: (state, action) => {
      const newItem = action.payload;
      const existingItem = state.cartItems.find(
        (item) => item.ProductId === newItem.ProductId
      );
      if (existingItem) {
        existingItem.Quantity++;
        existingItem.TotalPrice += Number(newItem.Price);
      } else {
        state.cartItems.push({
          ProductId: newItem.ProductId,
          ProductName: newItem.ProductName,
          description: newItem.description,
          time: newItem.time,
          Price: newItem.Price,
          TotalPrice: newItem.Price,
          image: newItem.image,
          Quantity: 1,
          ItemNote: newItem.ItemNote,
          inclusiveTax: newItem.inclusiveTax,
          sellPrice: newItem.sellPrice,
        });
      }
      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },
    removeFromCart: (state, action) => {
      const delItemid = action.payload;

      const existingItem = state.cartItems.find(
        (item) => item.ProductId === delItemid.ProductId
      );

      if (existingItem.Quantity === 1) {
        state.cartItems = state.cartItems.filter(
          (item) => item.ProductId !== delItemid.ProductId
        );
      } else {
        existingItem.Quantity--;
        existingItem.TotalPrice -= existingItem.Price;
      }
      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },
    setShowCartModal: (state, action) => {
      state.showCartModal = action.payload;
    },
    setTotalPrice: (state, action) => {
      state.TotalPrice = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setShowSection: (state, action) => {
      state.showSection = action.payload;
    },
    setDeletedPrice: (state, action) => {
      state.DeletedPrice = action.payload;
    },
    setCartItems: (state, action) => {
      state.cartItems = action.payload;
    },
    setLoadSubCat: (state, action) => {
      state.loadSubCat = action.payload;
    },
    setLoadProducts: (state, action) => {
      state.loadProducts = action.payload;
    },
    setAllProducts: (state, action) => {
      state.all_products = action.payload;
    },
    setSubCategory: (state, action) => {
      state.sub_category = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCompanyName: (state, action) => {
      state.companyName = action.payload;
    },
    setPreviewItem: (state, action) => {
      state.previewItem = action.payload;
    },
    setPreviewedItem: (state, action) => {
      state.previewedItem = action.payload;
    },
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setSearchResult: (state, action) => {
      state.searchResult = action.payload;
    },
    setSearchValue: (state, action) => {
      state.searchedValue = action.payload;
    },
    setSaveCard: (state, action) => {
      state.saveCard = action.payload;
    },
    setDeliveryMethod: (state, action) => {
      state.deliveryMethod = action.payload;
    },
    setPlaceOrder: (state, action) => {
      state.placeOrder = action.payload;
    },
    setMenuType: (state, action) => {
      state.menu_type = action.payload;
    },
    setSearch: (state, action) => {
      state.item_search = action.payload;
    },
    setIndoorSelected: (state, action) => {
      state.indoor_selected_value = action.payload;
    },
    setReview: (state, action) => {
      state.review = action.payload;
    },
    setReviewQuestions: (state, action) => {
      state.reviewQuestions = action.payload;
    },
    setApprovedOrder: (state, action) => {
      state.approvedOrder.push(action.payload);
      // state.approvedOrder = action.payload;
    },
    clearApprovedOrder: (state, action) => {
      state.approvedOrder = [];
    },
    setHoldApproval: (state, action) => {
      state.holdApproval = action.payload;
    },
    setGroupId: (state, action) => {
      state.groupId = action.payload;
    },
    setActiveGroup: (state, action) => {
      state.activeGroup = action.payload;
    },
    setEmenuOrderId: (state, action) => {
      state.emenuOrderId = action.payload;
    },
    setConfirmCancel: (state, action) => {
      state.confirmCancel = action.payload;
    },
    setAcceptAwaiting: (state, action) => {
      state.acceptAwaiting = action.payload;
    },
    setAcceptStatus: (state, action) => {
      state.acceptStatus = action.payload;
    },
    setQuestionDetails: (state, action) => {
      state.questionDetails = action.payload;
    },
    setTableMenuId: (state, action) => {
      state.tableMenuId = action.payload;
    },
    setViewOrder: (state, action) => {
      state.viewOrder = action.payload;
    },
    setViewItems: (state, action) => {
      state.viewItems = action.payload;
    },
    setOrderDetails: (state, action) => {
      state.orderDetails = action.payload;
    },
    setAddFavouriteProduct: (state, action) => {
      state.favouriteProduct.push(action.payload);
      localStorage.setItem(
        "Favourites",
        JSON.stringify(state.favouriteProduct)
      );
      // console.log(action.payload);
    },
    setFavouriteProduct: (state, action) => {
      state.favouriteProduct = action.payload; // Clear the favouriteProduct array
    },
    setFavouritePage: (state, action) => {
      state.favouritePage = action.payload;
    },
    unsetFavouriteProduct: (state, action) => {
      const payload = action.payload;
      const existingProduct = state.favouriteProduct.filter(
        (product) => product.ProductId === payload.ProductId
      );
      console.log(JSON.stringify(existingProduct));
      if (existingProduct) {
        state.favouriteProduct = state.favouriteProduct.filter(
          (product) => product.ProductId !== existingProduct[0].ProductId
        );
        // console.log(JSON.stringify(removeProduct));
        localStorage.setItem(
          "Favourites",
          JSON.stringify(state.favouriteProduct)
        );
      }
    },
    setWaiterCall: (state, action) => {
      state.waiterCall = action.payload;
    },
  },
});

export const EMenuActions = EMenuSlice.actions;

export default EMenuSlice;
